import { Link, useRouterState } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Eyebrow } from "@/components/marketing/primitives";

export function NotFoundPage() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  return (
    <main className="not-found-page">
      <div className="not-found-column">
        <Eyebrow>Error 404</Eyebrow>
        <section className="destination-notice" aria-label="Destination not working">
          <div className="destination-notice-header">
            <span className="destination-disapproved">Disapproved</span>
            <span className="destination-ad">Ad · berkhospitality.com</span>
          </div>
          <dl className="destination-notice-body">
            <div><dt>Policy</dt><dd>Destination not working</dd></div>
            <div><dt>Destination</dt><dd><code>berkhospitality.com{pathname}</code></dd></div>
            <div><dt>What happened</dt><dd>This page doesn&apos;t exist, or it moved.</dd></div>
          </dl>
          <div className="destination-notice-footer">
            <Button asChild className="destination-appeal"><Link to="/">Appeal: go to the homepage</Link></Button>
            <Button asChild variant="link" className="destination-audit"><Link to="/audit">Run a free audit</Link></Button>
          </div>
        </section>
        <nav className="fix-destination" aria-labelledby="fix-destination-heading">
          <h2 id="fix-destination-heading">Fix destination</h2>
          <ul>
            <li><Link to="/services">Services <span aria-hidden="true">→</span></Link></li>
            <li><Link to="/industries">Industries <span aria-hidden="true">→</span></Link></li>
            <li><Link to="/research/conversion-tracking-report">Conversion tracking report <span aria-hidden="true">→</span></Link></li>
            <li><Link to="/contact">Contact <span aria-hidden="true">→</span></Link></li>
          </ul>
        </nav>
      </div>
    </main>
  );
}